// extracted by mini-css-extract-plugin
export default {"container":"onboard_container__j2h2x","content":"onboard_content__pkEsU","shadow":"onboard_shadow__MIROt"};